export default __webpack_public_path__ + "static/media/squiggle_purple.e876bd88.svg";